import { z } from "zod";

const cursor = z.string().min(1);
const operationId = z.string().min(1);

export const notificationInboxStreamFrameSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("stream.ready"), headCursor: cursor }).strict(),
  z
    .object({ type: z.literal("stream.heartbeat"), headCursor: cursor })
    .strict(),
  z
    .object({
      type: z.literal("stream.resync_required"),
      reason: z.string().min(1),
    })
    .strict(),
  z.object({ type: z.literal("stream.shutdown") }).strict(),
  z
    .object({
      type: z.literal("notification.created"),
      cursor,
      notificationId: z.string().min(1),
      operationId,
    })
    .strict(),
  z
    .object({
      type: z.literal("notification.read_state_changed"),
      cursor,
      notificationId: z.string().min(1),
      operationId,
    })
    .strict(),
  z
    .object({
      type: z.literal("notification.deleted"),
      cursor,
      notificationId: z.string().min(1),
      operationId,
    })
    .strict(),
]);

export type NotificationInboxChangeFrame = Extract<
  z.infer<typeof notificationInboxStreamFrameSchema>,
  { cursor: string }
>;
